<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns" :key="column">{{ column }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in data" :key="item._id">
        <td @click="navigate(item._id)" class="link-style"><a :href="'/#/admin/campaigns/' + item._id">{{ item.name }}</a></td>
        <td>{{ formatDate(item.startTime) }}</td>
        <td>{{ formatDate(item.endTime) }}</td>
        <td>{{ item.drivers.length }} Drivers</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    props: {
      columns: Array,
      data: Array
    },
    methods: {
      navigate (id) {
        this.$router.push('/admin/campaigns/' + id);
      },
      formatDate(date) {
        try {
          const newDate = new Date(date * 1000)
          let year = newDate.getFullYear();
          let month = (newDate.getMonth() + 1).toString().padStart(2, '0'); // +1 because months are 0-indexed
          let day = newDate.getDate().toString().padStart(2, '0');
  
          return `${year}-${month}-${day}`;
        } catch (error) {
          console.log('formatDateError', error)
          return date
        }
      }
    }
  }
</script>
<style>
.link-style {
  cursor: pointer; /* Changes cursor to hand symbol */
}
</style>
